import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
interface ToggleRendererParams<T = Record<string, unknown>>
  extends ICellRendererParams<T> {
  field?: string;
  onChange?: (
    checked: boolean,
    rowData: T | undefined,
    params: ICellRendererParams<T>
  ) => void;
}

@Component({
  selector: 'lib-switch-toggle',
  standalone: true,
  imports: [MatSlideToggleModule],
  templateUrl: './switch-toggle.component.html',
  styleUrls: ['./switch-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchToggleComponent<T extends Record<string, unknown>>
  implements ICellRendererAngularComp
{
  private field = '';

  readonly checked = signal(false);

  private params?: ToggleRendererParams<T>;

  agInit(params: ToggleRendererParams<T>): void {
    this.initialize(params);
  }

  refresh(params: ToggleRendererParams<T>): boolean {
    this.initialize(params);
    return true;
  }

  onToggle(checked: boolean): void {
    this.checked.set(checked);
    if (!this.params || !this.field) {
      return;
    }
    this.params.node?.setDataValue(this.field, checked);
    this.params.onChange?.(checked, this.params.data, this.params);
  }
  private initialize(params: ToggleRendererParams<T>): void {
    this.params = params;
    this.field = params.field ?? '';

    const value =
      this.field && params.data ? params.data[this.field as keyof T] : false;
    this.checked.set(Boolean(value));
  }
}
